import { render, staticRenderFns } from "./Destiny.vue?vue&type=template&id=d23bc454&"
import script from "./Destiny.vue?vue&type=script&lang=js&"
export * from "./Destiny.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports